module.exports = {
          srcSet: __webpack_public_path__ + "public/235922c6ba03378293988993b2464b54-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/235922c6ba03378293988993b2464b54-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/235922c6ba03378293988993b2464b54-80.png",
          toString:function(){return __webpack_public_path__ + "public/235922c6ba03378293988993b2464b54-80.png"},
          
          width: 80,
          height: 80
        }